<template>
  <b-container>
     <b-table :items="pairsWithVoteCounts" :fields="fields">
       <template #cell(details)="data">
         <b-button @click="navigateToDetails(data.item)">szczegóły</b-button>
      </template>
     </b-table>



  </b-container>
</template>

<script>

import {api} from '@/utils'

export default {
  name: 'PairsPage',
  props: ["axios"],
  data: function () {
    return {
      pairsWithVoteCounts: [],
      fields : [
        {key: "id", label: "Id pary"},
        {key: "count", label: "Ilość głosów"},
        {key: "details", label: "Szczegóły"}

      ]
    }
  },
  created() {
    this.loadItems()
  },
  methods: {
    loadItems() {
      this.axios.get(api("pairs/0"))
          .then(resp => {
            this.pairsWithVoteCounts = resp.data.items;
          })

    },
    navigateToDetails(pair){
      this.$router.push({path: `/pair/${pair.id}`})
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
